<template>
  <el-form label-width="100px">
    <el-row>
      <el-col :span="8">
        <el-form-item label="会员OpenID">
          <el-input v-model="detailsData.consumerOpenId" readonly></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="会员昵称">
          <el-input v-model="detailsData.consumerName" readonly></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="生日">
          <el-input v-model="detailsData.dateOfBirth" readonly></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="手机号">
          <el-input v-model="detailsData.consumerPhone" readonly></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="常驻区域">
          <el-input v-model="detailsData.areaToBelong" readonly></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="注册时间">
          <el-input v-model="detailsData.registrationDate" readonly></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="常用酒区域">
          <el-input v-model="detailsData.commonlyAddress" readonly></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="购酒渠道偏好">
          <el-input v-model="detailsData.commonlyChannel" readonly></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="系列偏好">
          <el-input v-model="detailsData.seriesPreferencesName" readonly></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="度数偏好">
          <el-input v-model="detailsData.commonlyDegree" readonly></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <div class="form-title">收货地址</div>
        <vxe-table :data="list">
          <vxe-table-column field="provinceName" title="省"></vxe-table-column>
          <vxe-table-column field="cityName" title="市"></vxe-table-column>
          <vxe-table-column field="districtName" title="区"></vxe-table-column>
          <vxe-table-column field="address" title="详细地址"></vxe-table-column>
          <vxe-table-column field="contactPersonName" title="联系人"></vxe-table-column>
          <vxe-table-column field="contactPersonPhone" title="联系人电话"></vxe-table-column>
          <vxe-table-column field="isDefault" title="是否默认地址">
            <template #default="{ row }">
              <div>{{ row.isDefault === '1' ? '是' : '否' }}</div>
            </template>
          </vxe-table-column>
        </vxe-table>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>
import request from '@/found/utils/request';

export default {
  props: {
    value: {
      type: Object,
      default() {
        return {
        };
      },
    },
  },
  watch: {
    value: {
      handler(val) {
        if (val) {
          this.detailsData = val;
          this.getPagelist();
          console.log(val);
        }
      },
      immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      detailsData: {},
      list: [],
    };
  },
  methods: {
    // 获取详情
    getPagelist() {
      if (this.detailsData.consumerOpenId) {
        const params = {
          consumerOpenId: this.detailsData.consumerOpenId,
          pageSize: 1000,
        };
        const url = '/cps/v1/memberUserDeliveryAddress/memberUserDeliveryAddress/findByConditions';
        request.post(url, params).then((res) => {
          if (res.success) {
            this.list = res.result.data || [];
          }
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.form-title {
  font-size: 16px;
  height: 20px;
  line-height: 20px;
  font-weight: 600;
  margin-bottom: 10px;
}
</style>
